// extracted by mini-css-extract-plugin
export default {"home":"Home_home__MRplz","container":"Home_container__8vjgv"};